module.exports = __webpack_public_path__ + "static/img/6.e0633a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/eng/6.png
// module id = iTMN
// module chunks = 0